import { AirbridgeHelper } from 'core/airbridge'
import { LINK_MOVE_TYPE } from 'core/constants'
import { getConfig, getParam } from 'core/singleton'
import qs from 'qs'

export function getUrlQueryParameter<T extends Record<string, string>>(): T {
  const parsedQueryString = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  return parsedQueryString as T
}

export function parseObjectToQueryString<T extends Record<string, unknown>>(
  queryObject: T,
  startAt = '?',
) {
  const config = getConfig()
  let resultUrl = startAt

  const keyList = Object.keys(queryObject) as (keyof T)[]

  keyList.forEach((keyName, index) => {
    if (queryObject[keyName] === undefined) {
      return
    }

    if (index !== 0) {
      resultUrl += '&'
    }
    if (config?.guestLogin?.use && keyName === 'accessToken') {
      return
    }

    resultUrl += `${String(keyName)}=${queryObject[keyName]}`
  })

  return resultUrl
}

/**
 * @name moveToLink
 * @description 지정된 링크로 이동하는 함수.
 * @param {boolean} airbridge  airbridge 사용여부 (Optional)
 * @param {string} link 이동할 링크 (Required)
 * @param {LINK_MOVE_TYPE} type 이동 방식 (Optional)
 * @param {string} confirmedAlarmMemberId 알람 비회원 데이터 전달용 (Optional)
 * @returns {void} 없음
 */
export function moveToLink({
  airbridge,
  link,
  type = LINK_MOVE_TYPE.REDIRECT,
  confirmedAlarmMemberId,
}: {
  airbridge?: AirbridgeHelper
  confirmedAlarmMemberId?: string
  link: string
  type: LINK_MOVE_TYPE
}): void {
  if (!link) return

  const url = new URL(link)

  const params = [
    'fc',
    '_gl',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_campaign',
    'utm_term',
  ]

  params.forEach((param) => {
    const value = getParam(param)
    if (value && !url.search.includes(param)) {
      url.searchParams.append(param, value)
    }
  })
  if (confirmedAlarmMemberId) {
    url.searchParams.append('confirmedAlarmMemberId', confirmedAlarmMemberId)
  }

  if (airbridge) {
    airbridge.redirect({ url: url.href, isOpenNewWindow: type === LINK_MOVE_TYPE.NEW_WINDOW })
    return
  }

  if (type === LINK_MOVE_TYPE.REDIRECT) {
    window.location.href = url.href
  }
  if (type === LINK_MOVE_TYPE.REPLACE) {
    window.location.replace(url.href)
  }
  if (type === LINK_MOVE_TYPE.NEW_WINDOW) {
    window.open(url.href)
  }
}

export const addMarketingParams = (link: string) => {
  const { use } = getConfig().marketingGTM

  if (!use) return link

  const url = new URL(link)
  const params = [
    'fc',
    '_gl',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_campaign',
    'utm_term',
  ]

  params.forEach((param) => {
    const value = getParam(param)
    if (value && !url.search.includes(param)) {
      url.searchParams.append(param, value)
    }
  })

  return url.href
}

export const checkIsLocalhost = () => {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
}
